var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValores2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 150,
    viewBox: "0 0 155 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 76,
    r: 72,
    stroke: "#0885C7",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFCD00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.449 30.5C28.8657 30.5 29.1949 30.6167 29.4365 30.85C29.6782 31.075 29.799 31.375 29.799 31.75V34H16.999V32.75C16.999 32.5083 17.049 32.25 17.149 31.975C17.249 31.7 17.424 31.45 17.674 31.225L22.924 25.9375C23.374 25.4875 23.7657 25.0583 24.099 24.65C24.4324 24.2417 24.7074 23.8417 24.924 23.45C25.1407 23.05 25.3032 22.6542 25.4115 22.2625C25.5199 21.8625 25.574 21.4417 25.574 21C25.574 20.275 25.399 19.7208 25.049 19.3375C24.7074 18.9458 24.1824 18.75 23.474 18.75C22.899 18.75 22.4115 18.9042 22.0115 19.2125C21.6199 19.5125 21.349 19.8875 21.199 20.3375C21.024 20.7958 20.7949 21.1 20.5115 21.25C20.2282 21.4 19.824 21.4333 19.299 21.35L17.249 20.9875C17.3824 20.0792 17.6365 19.2875 18.0115 18.6125C18.3949 17.9375 18.8657 17.375 19.424 16.925C19.9907 16.475 20.6365 16.1417 21.3615 15.925C22.0865 15.7 22.8657 15.5875 23.699 15.5875C24.599 15.5875 25.4074 15.7208 26.124 15.9875C26.849 16.2458 27.4657 16.6083 27.974 17.075C28.4824 17.5417 28.8699 18.1 29.1365 18.75C29.4115 19.3917 29.549 20.1 29.549 20.875C29.549 21.5417 29.4532 22.1583 29.2615 22.725C29.0782 23.2917 28.824 23.8333 28.499 24.35C28.174 24.8583 27.7949 25.3542 27.3615 25.8375C26.9365 26.3125 26.4824 26.7958 25.999 27.2875L22.4365 30.9375C22.8949 30.7958 23.349 30.6875 23.799 30.6125C24.249 30.5375 24.6657 30.5 25.049 30.5H28.449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 36.018V36H80.5045H56.4374V36.018C56.4374 40.6893 52.6576 44.4802 48 44.4802V86.7196C48 93.3582 51.3857 99.5387 56.9748 103.105L77.3337 116.077C79.2684 117.308 81.7316 117.308 83.6573 116.077L104.025 103.105C109.614 99.5477 113 93.3672 113 86.7196V44.4802C108.342 44.4802 104.563 40.6893 104.563 36.018ZM77.1994 87.7347L65.86 76.3619L70.3295 71.8792L77.2084 78.7784L90.6795 65.2675L95.149 69.7502L77.1994 87.7347Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValores2);
export default __webpack_public_path__ + "static/media/valores_2.dd3fae7f7f0d3270b69ef195213551c3.svg";
export { ForwardRef as ReactComponent };